<ng-container *ngIf="isCourseReserveWorkflowEnabled">
  <ng-container
    *ngIf="
      hasRequestCourseReservePermission;
      then showPending;
      else dontShowPending
    "
  >
  </ng-container>
  <ng-template
    #showPending
    [ngSwitch]="
      item.content?.content_type === 'course_reserve' && item.content?.status
    "
  >
    <span
      class="badge bg-success"
      *ngSwitchCase="DigitisationStatus.LIVE"
      i18n="@@courseReserveStatus-label-live"
      >Live</span
    >
    <span
      class="badge bg-warning"
      *ngSwitchCase="DigitisationStatus.PENDING"
      i18n="@@courseReserveStatus-label-pending"
      >Approved</span
    >
    <span
      class="badge bg-warning"
      *ngSwitchCase="DigitisationStatus.REFERRED"
      i18n="@@courseReserveStatus-label-referred"
      >Awaiting review</span
    >
    <span
      class="badge bg-danger"
      *ngSwitchCase="DigitisationStatus.REJECTED"
      i18n="@@courseReserveStatus-label-rejected"
      >Rejected</span
    >
    <span
      class="badge label-default"
      *ngSwitchCase="DigitisationStatus.WITHDRAWN"
      i18n="@@courseReserveStatus-label-withdrawn"
      >Withdrawn</span
    >
    <span
      class="badge label-default"
      *ngSwitchCase="DigitisationStatus.EXPIRED"
      i18n="@@courseReserveStatus-label-expired"
      >Expired</span
    >
  </ng-template>
  <ng-template #dontShowPending [ngSwitch]="item.content?.status">
    <span
      class="badge bg-success text-capitalize"
      *ngSwitchCase="DigitisationStatus.LIVE"
      i18n="@@courseReserveStatus-label-courseReserve"
      >Course Reserve</span
    >
  </ng-template>
</ng-container>
